import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isLang: "zh-CN",
    isLogin: false,
    // 目录
    isType: 0,
    // 要搜索的内容
    isSearch: "",
    isYi: false,
    // 是否点击了切换语言
    isCla: false,
    // 货币切换
    isCurrency: "USD",
    // 帮助中心目录
    isHelpMenu: "",
    isHelpL: {},
    isJump: {},
    // 是否二次登录验证 '0': '未验证', '1': '已验证'
    isVerification: "0",
    // 产品模块信息
    indexInfo: {},
    // 当前订单支付步骤位置  confirm确认续费订单页，pay提交订单页，success支付页
    currentStep: null,
    // 当前跳转云服务订单还是api
    orderType: "",
  },
  getters: {},
  mutations: {
    SET_INDEXINFO(state, value) {
      state.indexInfo = value;
    },
    SET_LANG(state, str) {
      state.isLang = str;
    },
    SET_JUMP(state, value) {
      state.isJump = value;
    },
    SET_ISHELPMENU(state, value) {
      state.isHelpMenu = value;
    },
    SET_ISHELPL(state, value) {
      state.isHelpL = value;
    },
    SET_CLA(state) {
      state.isCla = !state.isCla;
    },
    SET_MENU(state, value) {
      state.isYi = value;
    },
    SET_CURRENT(state, value) {
      state.current = value;
    },
    SET_ISSEARCH(state, value) {
      state.isSearch = value;
    },
    SET_LOGIN(state, value) {
      state.isLogin = value;
    },
    SET_TYPE(state, value) {
      state.isType = value;
    },
    SET_CLEAR(state, value) {
      state.isLogin = false;
      state.isType = null;
      state.isSearch = "";
      state.current = 0;
      state.isHelpMenu = "";
    },
    SET_CURRENTSTEP(state, value) {
      state.currentStep = value;
    },
    SET_ORDERTYPE(state, value) {
      state.orderType = value;
    },
    // 是否二次认证登录
    SET_VERIFICATION(state, value) {
      state.isVerification = value;
    },
    // 更新货币
    SET_ISCURRENCY(state, value) {
      state.isCurrency = value;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      key: "config",
      paths: [
        "isLogin",
        "isType",
        "isSearch",
        "isYi",
        "isCla",
        "isHelpMenu",
        "isHelpL",
        "isJump",
        "isLang",
        "indexInfo",
        "currentStep",
        "orderType",
        "isVerification",
        "isCurrency",
      ],
      storage: {
        getItem: (key) => localStorage.getItem(key),
        setItem: (key, value) => localStorage.setItem(key, value),
        removeItem: (key) => localStorage.removeItem(key),
      },
    }),
  ],
});

export default store;
